/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Notifications_DescriptionInputs */

const en_marketing_feature_notifications_description = /** @type {(inputs: Marketing_Feature_Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An in-app feed with realtime updates plus batched email digests.`)
};

const es_marketing_feature_notifications_description = /** @type {(inputs: Marketing_Feature_Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un feed dentro de la aplicación con actualizaciones en tiempo real y resúmenes por correo.`)
};

const fr_marketing_feature_notifications_description = /** @type {(inputs: Marketing_Feature_Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un fil intégré à l'application avec mises à jour temps réel et résumés e-mail groupés.`)
};

/**
* | output |
* | --- |
* | "An in-app feed with realtime updates plus batched email digests." |
*
* @param {Marketing_Feature_Notifications_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_notifications_description = /** @type {((inputs?: Marketing_Feature_Notifications_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Notifications_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_notifications_description(inputs)
	if (locale === "es") return es_marketing_feature_notifications_description(inputs)
	return fr_marketing_feature_notifications_description(inputs)
});